export { WavesDirective } from './waves-effect.directive';
export { WavesModule } from './waves.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/free/waves/index.ts